import { USER_DATA } from "@/utils/user";

export default {
	methods: {
		// Сам обработчик события
		handleLocalStorageUpdate(event) {
			if (event && event.detail && event.detail.key === USER_DATA.DEPOSIT) {
				this.deposit = event.detail.value;
				
				// Дополнительно: синхронизируем с локальной моделью инпута модального окна,
				// чтобы цифра в поле «Депозит» обновлялась на лету, если она изменилась глобально
				if (this.model) {
					this.model.deposit = event.detail.value;
				}
			}
		}
	}
};